module.exports = __webpack_public_path__ + "img/47.978694ca.jpg";